<template>
    <div class="refuelAdministrator">
       <Heador title='监督核销' :back="true"></Heador>


        <section>
            <div class="card-box">
                <div class="card">
                    <div class="plate">车牌号：{{ info.plateNumber }}</div>
                    <div class="title" v-if="info.userName">
                        司机：{{ info.userName }}
                    </div>
                    <!-- <div class="title" v-if="info.userPhone">司机手机号：{{ info.userPhone }}</div>
                    <div class="usable gapTop">
                        <span>申请燃油类型</span>
                        <span>{{ info.fuelType }}</span>
                    </div> -->
                    <div class="apply gapTop">
                        <span>计划加油升数</span>
                        <span>{{ parseMoneyFormat(info.planLiter) }} (升)</span>
                    </div>
                    <div class="usable gapTop">
                        <span>计划加油金额</span>
                        <span>{{ parseMoneyFormat(info.driverPlanMoney) }} (元)</span>
                    </div>
                    <div class="time gapTop">申请时间：{{ info.createTime }}</div>
                </div>
            </div>

            <div class="gap"></div>


            
            <div class='show-bottom'>
                <div class='show-bottom-title'>申请明细</div>
                <div class='show-bottom-text '>运单金额(元) / 项目油价(元/升) = 油量(升)</div>
                <div class='show-bottom-text '>油量(升) * 加油站油价(元/升) = 加油站实际金额(元)</div>


                <div class="item" v-for='consignment in info.recordVoList' :key='consignment.consignmentCode'>
                    <div class="card">
                        <div class="bottom common commonbt">
                            <div class="left ">
                                <span class="txt">运单号：</span>
                                <span class="num">{{ consignment.consignmentCode }}</span>
                            </div>
                        </div>

                        <div class="center">
                            <div class="one">
                                <div class="text">油量 :</div>
                                <div class="num" v-if="consignment.originalPrice">
                                    {{ parseMoneyFormat(consignment.originalPrice) }}
                                    /
                                    {{ parseMoneyFormat(consignment.projectFuelPrice) }}
                                    =
                                    {{ parseMoneyFormat(consignment.planLiter) }}
                                </div>
                            </div>
                        </div>
                        <!-- <div class="center">
                            <div class="one">
                                <div class="text">加油站金额 :</div>
                                <div class="num" v-if="consignment.originalPrice">
                                    {{ parseMoneyFormat(consignment.planLiter) }}
                                    *
                                    {{ parseMoneyFormat(consignment.stationFuelPrice) }}
                                    =
                                    {{ parseMoneyFormat(consignment.planLiter * consignment.stationFuelPrice) }}
                                </div>
                            </div>
                        </div> -->

                        <div class="top common">
                            <div class="left">
                                <span class="txt"></span>
                                <span class="num">{{ consignment.projectName }}</span>
                            </div>
                        </div>
                    </div>
                </div>


                <div>
                    <div class='show-bottom-bottom'>
                        <span class='total total-title'>合计升数:</span>
                        <span class='total'>{{ parseMoneyFormat(info.planLiter) }}(升)</span>
                    </div>
                    <div class='show-bottom-bottom'>
                        <span class='total total-title'>合计金额:</span>
                        <span class='total'>{{ parseMoneyFormat(info.driverPlanMoney) }}(元)</span>
                    </div>
                    <div class='show-bottom-bottom'>
                        <span class='total total-title'>申请时间:</span>
                        <span class='total'>{{ info.createTime }}</span>
                    </div>
                </div>

            </div>

            
           




            <div class="gap"></div>

             <div class='equipment'>
                <div class='show-bottom-title'>核销信息</div>
                <!-- <van-field
                  v-model="fieldValue"
                  is-link
                  readonly
                  label="核销设备"
                  placeholder="请选择核销设备"
                  required
                  @click="equipmentShow = true"
                />
                <van-popup v-model="equipmentShow" round position="bottom">
                  <van-cascader
                    v-model="cascaderValue"
                    title="请选择设备"
                    :options="options"
                    @close="equipmentShow = false"
                    @change="onChange"
                    @finish="onFinish"
                  />
                </van-popup>-->
            </div> 
            <!-- @click="opinionShow = true" -->
            <van-cell is-link   title="加注站"   :value='opinionText' />
            <van-action-sheet  v-model="opinionShow" :actions="options" @select="onSelect"  cancel-text="取消" @cancel="opinionShow = false"/>
            <van-cell is-link required title="加注设备" @click="opinionSonShowFn" :value='opinionSonCen.name' />
            <van-action-sheet v-model="opinionSonShow" :actions="optionsSon" @select="onSelectSon"  cancel-text="取消" @cancel="opinionSonShow = false"/>
            

            <div class="upLoad">
                <div>
                     <!-- <span style='color:red'>*</span> -->
                    <div class="upLoad-subTitle">车牌号 </div>
                    <div class="file-box">
                        <div class="img-box">
                            <div v-if="isH !== 'H5'">
                                <div
                                        class="upload-plus"
                                        @click="showPhoto('1')"
                                        v-if="!fileOne.img.length"
                                >
                                    <img
                                            src="@/assets/images/camera_upload.png"
                                            class="camera"
                                            alt=""
                                    />
                                </div>
                                <img
                                        :src="fileOne.img[0].outLink"
                                        alt=""
                                        class="upload-item-img"
                                        @click="onDelete('1')"
                                        v-else
                                />
                            </div>
                            
                           
                            <van-uploader v-else v-model="fileList" multiple :max-count="1" :after-read="afterRead" :before-delete='deleteimgone'/>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="upLoad-subTitle twoMargin">  加油信息 </div>
                    <div class="file-box">
                        <div class="img-box">
                            <div v-if="isH !== 'H5'">
                                <div
                                    class="upload-plus"
                                    @click="showPhoto('2')"
                                    v-if="!fileTwo.img.length"
                                 >
                                <img
                                        src="@/assets/images/camera_upload.png"
                                        class="camera"
                                        alt=""
                                />
                                 </div>
                                <img
                                        :src="fileTwo.img[0].outLink"
                                        alt=""
                                        class="upload-item-img"
                                        @click="onDelete('2')"
                                        v-else
                                />
                            </div>
                            
                            <van-uploader v-else v-model="fileListbt" multiple :max-count="1" :after-read="afterReadbt" :before-delete='deleteimgtwo' />

                        </div>
                    </div>
                </div>

            </div>

            
            <div class="bottom-input">
            <!-- <div class='show-bottom-title'>核销信息</div> -->
                <div class="input-box">
                    <span class="left">备注：</span>
                    <div class="item-ipt">
                        <van-field
                                v-model="adminConfirm.remark"
                                rows="3"
                                type="textarea"
                                maxlength="50"
                                placeholder="请输入备注"
                                show-word-limit
                        />
                    </div>
                </div>
            </div>


        </section>
        <footer>
            <van-button
                    v-if="showbtns"
                    class="btn shadow"
                    color="linear-gradient(0deg,#FC9C0A, #FEB022)"
                    @click="goAdminConfirm"
            >确认
            </van-button
            >
            <van-button
                    v-else
                    disabled
                    class="btn shadow"
                    color="linear-gradient(0deg,#FC9C0A, #FEB022)"
            >确认
            </van-button
            >
        </footer>

          <van-overlay :show="requesting">
            <div style="margin-top: 50vh">
                <van-loading size="24px" vertical>加载中...</van-loading>
            </div>
        </van-overlay>

         <van-overlay :show="requestingSave">
            <div style="margin-top: 50vh">
                <van-loading size="24px" vertical>核销中...</van-loading>
            </div>
        </van-overlay>

        <van-action-sheet v-model="show" :actions="actions" @select="onSelectImg"/>


    </div>
</template>

<script>
    import {Toast, Dialog} from "vant";
    import {getToken} from "@/utils/auth";
    import {preWatchWriteOff, allStation, allGun,watchWriteOff} from "@/api/center/verification";
    import { fileUploadAddress } from '@/utils/up.js'
    import Heador from "./header";
 

    export default {
        name: "",
        components: {
            Heador,
        },
        props: {},
        data() {
            return {
                maskShow:false,
                info:{},

                adminConfirm:{
                    remark:''
                },
                fileOne:{
                    img: [],
                },
                fileTwo:{
                    img: []
                },
                showbtns:true,

                //加油设备
                equipmentShow: false,
                fieldValue: '',
                cascaderValue: '',
                //选择加油站
                options: [],
                optionsSon:[],
                opinionShow:false,
                opinionSonShow:false,
                opinionText:'',
                opinionSonCen:{},
                actions: [
                    {name: "请选择", disabled: true},
                    {name: "拍照", color: "#3291f8"},
                    {name: "从相册获取", color: "#3291f8"},
                    {name: "取消", color: "#3291f8"},
                ],
                fileList:[],
                fileListbt:[],
                img:'',
                imgbt:'',
                fuelGunId:'',
                requesting:true,
                requestingSave:false,

                //壳子上传
                show:false,
                moduleId:'',
                isH:''
            }
        },
        created() {
      
        },
        mounted() {
            this.init()
            this.isH = this.androidIOS()
            console.log(this.isH);
            window.imageCallback = this.imageCallback;

            console.log(this.isH,'this.isH');

            // this.$toast(this.isH)
        },
        methods: {
            init(){
                this.getDetai()
            },
            // 判断是安卓还是IOS环境
            androidIOS() {
                var ua = window.navigator.userAgent.toLowerCase();
                //通过正则表达式匹配ua中是否含有MicroMessenger字符串
                 let u = navigator.userAgent;
                let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; // 判断是否是 android终端
                let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // 判断是否是 ios终端

                if(ua.match(/MicroMessenger/i) == 'micromessenger'){
                    return 'H5';
                }else{
                 if (isAndroid === true) {
                    // 安卓
                    return 'isAndroid';

                } else if (isIOS === true) {
                    // IOSxx
                    return 'isIOS';
                    // return 'H5';
                }
                }
            },
            showPhoto(moduleId) {
                // 调用IOS约定好的调用相册方法
                this.moduleId = moduleId;
                this.show = true;
                // if (this.frontid.img.length && moduleId == "10010") {
                //   this.handleDialog(this.frontid.id, moduleId);
                // } else {
                //   this.show = true;
                //   this.moduleId = moduleId;
                // }
            },
            onSelectImg(action, index) {
                console.log({ action, index },this.moduleId);
                let paramsObj = {
                    accessToken: this.getToken,
                    moduleId: this.moduleId,
                    // bizId: this.$route.query.orderId,
                    // url:process.env.VUE_APP_BASE_API + "/upload/admin",
                    securityLevel: "4",
                };
                // console.log('选中图片方法',index);
                // this.$toast('上传图片'+index)
                switch (index) {
                    // 拍照
                    case 1:
                        console.log(action.name);
                        if (this.isH === 'isAndroid') {
                            paramsObj = JSON.stringify(paramsObj);
                            window.revisionInterface.takePhoto(paramsObj);
                        }
                        if (this.isH ==='isIOS') {
                            try {
                                // Toast(1);
                                window.webkit.messageHandlers.takePhoto.postMessage(paramsObj);
                            } catch (e) {
                            }
                        }
                       
                        this.show = false;
                        break;
                    // 打开相册
                    case 2:
                        console.log(action.name);
                        if (this.isH === 'isAndroid') {
                            paramsObj = JSON.stringify(paramsObj);
                            window.revisionInterface.selectImage(paramsObj);
                        }
                        if (this.isH ==='isIOS') {
                            window.webkit.messageHandlers.selectImage.postMessage(paramsObj);
                        }
                        this.show = false;
                        break;
                    case 3:
                        this.show = false;
                        break;
                }
            },

            onDelete(moduleId) {
                // Toast(id)
                this.handleDialog(moduleId);
            },
            // 删除确认弹窗
            handleDialog(moduleId) {
                let _this = this;

                function beforeClose(action, done) {
                    if (action === "confirm") {
                        _this.deleteFiles(moduleId, done);
                    } else {
                        done();
                    }
                }

                Dialog.confirm({
                    title: "提示",
                    message: "是否删除已上传的附件",
                    beforeClose,
                });
            },
            // 删除附件函数
            deleteFiles(moduleId, callback) {
                if (moduleId == "1") {
                    this.fileOne.img = [];
                    this.img = ''
                }
                if (moduleId == "2") {
                    this.fileTwo.img = [];
                    this.imgbt = ''
                }
                callback && callback();
                this.$toast("删除成功");
            },
               // 暴露给安卓调用
            imageCallback(params) {
                var paramsObj = "";
                console.log(params,'params');
              
                if (this.isH ==='isIOS') {
                    paramsObj = JSON.parse(params);
                } else {
                    paramsObj = params;
                }


                // let { imageUrl, imageId } = paramsObj;
                // this.file.push({ outLink: imageUrl, id: imageId });
                let {imageUrl, moduleId} = paramsObj;
                // this.$toast('上传成功123'+moduleId)
                // this.file.push({ outLink: imageUrl });
                if (moduleId == "1") {
                    // this.frontid.img.push({ url: imageUrl });
                    // this.frontid.id = imageId;
                    console.log(imageUrl);
                    this.fileOne.img.push({outLink: imageUrl});
                    console.log(this.fileOne.img,'imgList');
                    this.img = imageUrl
                } else if (moduleId == "2") {
                    // this.backid.img.push({ url: imageUrl });
                    // this.backid.id = imageId;
                    this.fileTwo.img.push({outLink: imageUrl});
                    this.imgbt = imageUrl

                }
            },
            //获取详情
            getDetai(){
                preWatchWriteOff(this.$route.query.id).then(res=>{
                    // console.log(res);
                    if(res.data.code === 200){
                        this.info = res.data.data
                        this.requesting = false
                        this.getCheer()
                    }else{
                        this.$router.back()
                    }
                })
            },
            //获取加油站
            getCheer(){
                allStation().then(res=>{
                    let arr = res.data.data

                    for(let i=0;i<arr.length;i++){
                        console.log(arr[i],this.info.fuelStationId);
                       if(arr[i].key == this.info.fuelStationId){
                        //    console.log('进入判断',this);
                           this.opinionText = arr[i].value
                           this.onSelect(arr[i])
                       }
                    }
                  
                })

                return
                allStation().then(res=>{
                    // console.log(res);
                    if(res.data.code === 200){
                        let list = []
                        res.data.data.forEach((v,i)=>{
                            list.push({name:v.value,value:v.key,children:[]})
                        })
                        this.options = list
                        console.log(this.options);
                    }
                })
            },
            //选择加注站
            onSelect(item){
                // this.opinionShow = false;
                // this.optionsSon = []
                allGun(item.key).then(res=>{
                    if (res.data.code === 200) {
                        this.optionsSon = res.data.data
                        
                        console.log(this.optionsSon,'son');
                    }
                })

                // this.opinionText = item.name
                // this.opinionSonCen = {}
            },
            onSelectSon(item){
                this.opinionSonShow = false;

                this.opinionSonCen = item

            },
            opinionSonShowFn(){
                if(!this.opinionText){
                    Toast('请先选择加注站')
                    return

                }else if(!this.optionsSon.length){
                    Toast('加载中')
                    return
                }
                this.opinionSonShow = true;
            },
               
            //  onChange( item ) {
            //      console.log(item);
       
            //     console.log(item,item.value);
            //     let num
            //     this.options.forEach((v,i)=>{
            //        if(item.value === v.value) num = i
            //     })
                
            //     // console.log(num);
            //      this.options[num].children.push({text:'加载中.....',value:'dol',disabled: true})

            //       allGun(item.value).then(res=>{
            //         // console.log(res);
            //         if (res.data.code === 200) {
            //               this.options[num].children = [];
            //                 res.data.data.forEach(v=>{
            //                     this.options[num].children.push({text:v.name,value:v.id,...v})
            //                 })
            //                 // console.log(this.options);
            //         }
            //     })
  
                
            // },
            // onFinish(item) {
            //     console.log(item);
            //   this.equipmentShow = false;
            //   this.fieldValue = item.selectedOptions.map((option) => option.text).join('/');
            //   this.fuelGunId = item.selectedOptions.map((option) => option.value)[1];
            // },
            //图片上传
             afterRead(file) {
                file.status = 'uploading';
                file.message = '上传中...';
                let formData = new FormData();
               
                formData.append("file", file.file);
                
                fileUploadAddress(formData).then(res=>{
                    console.log(res);
                    this.img = res.url
                    file.status = '';
                })
                console.log(file,1, this.img);
                // alert(file)
            },
            afterReadbt(file) {
                file.status = 'uploading';
                file.message = '上传中...';
                let formData = new FormData();
                
                formData.append("file", file.file);
                fileUploadAddress(formData).then(res=>{
                    console.log(res);
                    this.imgbt = res.url
                     file.status = '';
                })
                console.log(file,1, this.imgbt);
            },
            //图片删除
            deleteimgone(){
                this.fileList = []
                this.img = ''
            },
            deleteimgtwo(){
                this.fileListbt = []
                this.imgbt = ''
            },
        
            goAdminConfirm(){
                if (!this.opinionSonCen.id) {
                    this.$toast("请选择加油设备！");
                    return;
                }
                //  if (!this.img.length) {
                //     this.$toast("请上传车牌号！");
                //     return;
                // }
                // if (!this.imgbt.length) {
                //     this.$toast("请上传加油信息！");
                //     return;
                // }
                // if(!((!this.img.length && !this.imgbt.length) || !(this.imgbt.length&&this.imgbt.length))){
                //     this.$toast("请上传两张图 或 不上传图片!");
                //     return
                // }
                this.requestingSave = true

                let one,two
                if(this.isH === 'H5'){
                    one = this.img;
                    two = this.imgbt;
                }else{
                    one = this.fileOne.img[0]?this.fileOne.img[0].outLink:undefined;
                    two = this.fileTwo.img[0]?this.fileTwo.img[0].outLink:undefined;
                }
                    // let imgConcatList = `${one},${two}`;
                let imgConcatList = '';
                if(one){
                    imgConcatList += one
                }
                if(two){
                    if(imgConcatList){
                        imgConcatList += ',' + two
                    }else{
                        imgConcatList +=  two
                    }

                }
              
                // console.log(this.img,this.imgbt,one,two,imgConcatList); 
                let obj ={
                    applyId:this.$route.query.id,
                    fuelGunId:this.opinionSonCen.id,
                    remark:this.adminConfirm.remark,
                    imgs:imgConcatList,
                    adminActualMoney:this.info.adminPlanMoney,
                    actualLiter:this.info.planLiter
                }
                watchWriteOff(obj).then(res=>{
                    console.log(res);
                    if(res.data.code === 200){

                           Toast({
                                message: res.data.msg,
                                duration: 200,
                            });
                          
                        this.$router.push({
                                path: "/refuelDetail",
                                query: {
                                    id: this.$route.query.id,
                                    info: res.data.data,
                                },
                        });
                    }
                        this.requestingSave = false

                })
            }
        },
        computed: {},
        watch: {},
    };
</script>
<style lang="less" scoped>
    .refuelAdministrator {
        width: 100vw;
        height: 100vh;
    }

    section {
        height: calc(100vh - 2.3rem /* 115/50 */);
        overflow: scroll;

        .card-box {
            width: 100%;
            box-sizing: border-box;
            padding: 0.4rem /* 20/50 */ 0.3rem /* 15/50 */;
            background: #fff;

            .card {
                box-sizing: border-box;
                padding: 0.3rem /* 15/50 */;
                background: linear-gradient(0deg, #fc9c0a, #feb022);
                box-shadow: 0px 0px 10px 0px rgba(7, 63, 53, 0.1);
                border-radius: 5px;
                font-size: 0.36rem /* 18/50 */;
                font-family: PingFang SC;
                font-weight: 500;
                color: #ffffff;

                .plate {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }

                .title {
                    margin-top: 0.2rem /* 10/50 */;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 0.28rem /* 14/50 */;
                }

                .usable {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }

                .apply {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }

                .time {
                    text-align: right;
                    font-size: 0.24rem /* 12/50 */;
                }

                .gapTop {
                    margin-top: 0.3rem /* 15/50 */;
                }
            }
        }

        .gap {
            width: 100%;
            height: 0.2rem /* 10/50 */;
            background: #f2f2f2;
        }

        .equipment{
            width: 100%;
            box-sizing: border-box;
            background: #fff;
        }

        .bottom-input {
            width: 100%;
            box-sizing: border-box;
            background: #fff;

            .input-box {
                margin: 0 auto;
                width: 92%;
                border-bottom: 1px solid #efefef;
                padding: 0.4rem /* 20/50 */ 0;
                display: flex;
                justify-content: space-between;
                font-size: 0.32rem /* 16/50 */;
                font-family: PingFang SC;
                font-weight: 500;
                color: #7e7e7e;

                .item-ipt {
                    width: 60%;
                }

                .info-input {
                    width: 80%;
                    text-align: right;
                }

                .nuit {
                    display: inline-block;
                    margin-left: 3px;
                }

                ::-webkit-input-placeholder {
                    text-align: right;
                    color: #aeaeae;
                }

                :-moz-placeholder {
                    /* Firefox 18- */
                    text-align: right;
                    color: #aeaeae;
                }

                ::-moz-placeholder {
                    /* Firefox 19+ */
                    text-align: right;
                    color: #aeaeae;
                }

                :-ms-input-placeholder {
                    text-align: right;
                    color: #aeaeae;
                }
            }
        }

        .upLoad {
            padding: 0.4rem /* 20/50 */ 0.3rem /* 15/50 */;
            display: flex;
            justify-content: space-around;
            background-color: #fff;

            .upLoad-bigTitle {
                font-size: 0.32rem /* 16/50 */;
                font-family: PingFang SC;
                font-weight: 500;
                color: #333333;
                margin-bottom: 0.4rem /* 20/50 */;
            }

            .upLoad-subTitle {
                text-align: center;
                font-size: 0.32rem /* 16/50 */;
                font-family: PingFang SC;
                font-weight: 500;
                color: #333333;
                margin-bottom: 0.3rem /* 15/50 */;
            }

            .twoMargin {
                // margin-top: 0.3rem /* 15/50 */;
            }

            .file-box {
                width: 100%;
                // display: flex;
                // flex-wrap: wrap;
                .img-box {
                    width: 2rem /* 100/50 */;
                    // margin: 0.4rem /* 20/50 */ 0.26rem /* 13/50 */ 0 0;
                    .upload-item-img {
                        width: 2rem /* 100/50 */;
                        height: 2rem /* 100/50 */;
                    }
                    text-align: center;
                }
            }

            .upload-plus {
                width: 2rem /* 100/50 */;
                height: 2rem /* 100/50 */;
                background: #f2f2f2;
                border: 1px solid #e0e0e0;
                border-radius: 5px;
                display: flex;
                justify-content: center;
                align-items: center;
                // margin: 0.4rem /* 20/50 */ 0.26rem /* 13/50 */ 0 0;
                .camera {
                    width: 0.72rem /* 36/50 */;
                }
            }
        }
    }

    footer {
        position: fixed;
        bottom: 0;
        right: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 1.3rem /* 65/50 */;
        background: #ffffff;
        box-shadow: 0px 0px 10px 0px rgba(28, 35, 78, 0.1);
        box-sizing: border-box;
        padding: 0 0.32rem /* 16/50 */;

        .btn {
            width: 100%;
            height: 0.9rem /* 45/50 */;
            border-radius: 5px;
            font-size: 0.36rem /* 18/50 */;
            font-family: PingFang SC;
            font-weight: 500;
        }

        .cancel {
            border: 1px solid #e0e0e0 !important;
        }

        .shadow {
            box-shadow: 0px 0px 10px 0px rgba(7, 63, 53, 0.1);
        }
    }

    .black {
        width: 100vw;
        height: 500px;
        background: #000;
    }

    .mask {
        position: fixed;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        background-color: rgba(28, 31, 20, 0.3);
        z-index: 99999;

        .affirm {
            display: flex;
            flex-direction: column;
            width: 60%;
            height: 48vw;
            border-radius: .2rem;
            background-color: #f2f2f2;

        }

        .affirmtwe {
            display: flex;
            flex-direction: column;
            width: 60%;
            height: 30vw;
            border-radius: .2rem;
            background-color: #f2f2f2;
        }
    }

    .title-top {
        margin-top: .3rem;
        text-align: center;
        font-size: .32rem;
    }

    .title-text {
        text-align: center;
        margin-top: .12rem;

    }

    .title-btn {
        display: flex;
        flex: 1;
        justify-content: space-between;
    }

    .btn-btn {
        margin-top: .2rem;

        width: 50%;
        text-align: center;
        padding-top: .2rem;
        border-top: .03rem solid #ccc;
    }

    .btn-btn:nth-child(1) {
        border-right: .03rem solid #ccc;
    }


    .show-bottom-main {
        display: -webkit-box;
        overflow-x: scroll;
        -webkit-overflow-scrolling: touch;
        flex-direction: column;
        text-align: center;
        // background-color: red;
        margin: .2rem 0;

        &::-webkit-scrollbar {
            width: 0;
            height: 0;
            display: none;
        }

        .show-list {
            display: flex;
            margin: .2rem 0;

            div {
                min-width: 2rem;
                padding: 0 .2rem;
            }

            .show-first {
                min-width: 4rem;
                padding-right: .2rem;
            }
        }
    }

    .item {
        width: 100%;
        margin: .3rem 0;

        .title {
            font-size: 0.32rem /* 16/50 */;
            font-family: PingFang SC;
            font-weight: bold;
            color: #ff9e02;
            margin: 0.3rem /* 15/50 */ 0;
        }

        .card {
            // background: #ffffff;
            width: 96%;
            margin-left: 2%;
            /*box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);*/
            /*border-radius: 0.2rem !* 10/50 *!;*/
            /*border: 1px solid #e1e1e1;*/

            .top {
                border-bottom: 1px solid #efefef;
            }

            .common {
                display: flex;
                justify-content: space-between;
                padding: 0.26rem /* 13/50 */;
                padding-top: 0;

                font-size: 0.28rem /* 14/50 */;
                font-family: PingFang SC;
                font-weight: 700;
                color: #7e7e7e;

                .left-text {
                    width: 50%;
                    overflow: hidden;
                }

                .txt {
                    font-weight: 400;
                    color: #7e7e7e;
                }

                .yellow {
                    color: rgb(254, 176, 34);
                }

                .black {
                    // color: #28347C;
                    color: #333333;
                }

                .red {
                    color: #dd191d;
                }

                .blue {
                    color: #455ede;
                }

                .grey {
                    color: #aeaeae;
                }
            }

            .commonbt {
                padding-top: 0;
                padding-bottom: 0;
                /*margin-top: -.2rem;*/
            }

            .center {
                display: flex;
                justify-content: space-between;
                padding: 0.26rem /* 13/50 */;

                .one {
                    font-size: 0.28rem /* 16/50 */;
                    font-family: PingFang SC;
                    font-weight: bold;
                    /*color: #333333;*/
                    /*width: 33%;*/

                    .num {
                        /*margin-bottom: 0.26rem !* 13/50 *!;*/
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }

                    .text {
                        font-size: 0.28rem /* 14/50 */;
                        font-family: PingFang SC;
                        font-weight: 400;
                        color: #7e7e7e;
                    }
                }
            }

            /*.bottom {*/
            /*    border-top: 1px solid #efefef;*/
            /*}*/
        }
    }

    .show-bottom-bottom {
        display: flex;
        justify-content: space-between;
        padding: .26rem 5%;
        font-weight: 700;
    }


    .right-text {
        width: 50%;
    }

    .one {
        /*text-align: right;*/
        display: flex;
        justify-content: space-between;
        width: 100%;
        /*text-align: center;*/
    }

    .center {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
    }

    .show-bottom {
        margin-top: .3rem;
        width: 100vw;
        background-color: #fff;
    }

    .show-bottom-text,
    .show-bottom-title {
        padding: .4rem 0 0 4% ;
        text-align: left;
    }

    .show-bottom-title {
        height: .5rem;
        font-size: .36rem;
        font-weight: 600;
    }

    .show-bottom-text {
        color: #7e7e7e;
        font-size: .32rem;
    }

    .numberPlate-title {
        text-align: center;
        font-size: .5rem;
    }

    .total-title {
        color: #7e7e7e;
        font-size: .32rem;
    }
    .total{
        font-size: .32rem;
    }


 
</style>
